import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { productApi, type Relationship } from '../../api/products';

export function ProductRelationshipsPage() {
  const { id = '' } = useParams();
  const [items, setItems] = useState<Relationship[]>([]);
  const [relatedId, setRelatedId] = useState('');
  const [relType, setRelType] = useState('related');

  async function load() {
    setItems(await productApi.relationships(id));
  }

  useEffect(() => { void load(); }, [id]);

  async function add(e: React.FormEvent) {
    e.preventDefault();
    if (!relatedId.trim()) return;
    await productApi.addRelationship(id, { related_id: relatedId.trim(), type: relType });
    setRelatedId('');
    await load();
  }

  return (
    <div className="mx-auto max-w-3xl p-6">
      <Link to={`/products/${id}`} className="text-sm text-slate-600 hover:underline">← Product</Link>
      <h1 className="mt-4 text-2xl font-semibold">Product Relationships</h1>
      <form onSubmit={(e) => void add(e)} className="mt-6 flex flex-wrap gap-3">
        <input value={relatedId} onChange={(e) => setRelatedId(e.target.value)} placeholder="Related product ID" className="flex-1 rounded-lg border px-3 py-2 text-sm" />
        <select value={relType} onChange={(e) => setRelType(e.target.value)} className="rounded-lg border px-3 py-2 text-sm">
          <option value="related">Related</option>
          <option value="variant">Variant</option>
          <option value="accessory">Accessory</option>
          <option value="bundle_component">Bundle component</option>
        </select>
        <button type="submit" className="rounded-lg border px-4 py-2 text-sm">Add</button>
      </form>
      <ul className="mt-6 space-y-2 text-sm">
        {items.map((r) => (
          <li key={r.id} className="rounded-lg border px-4 py-2">{r.type} → {r.related_id}</li>
        ))}
        {items.length === 0 && <p className="text-slate-500">No relationships yet.</p>}
      </ul>
    </div>
  );
}
